import TheChalkboard from './TheChalkboard'
import TheSoundMachine from './theSoundMachine/TheSoundMachine'
import TheLockBox from './TheLockBox'
import TheSimonMachine from './theSimonMachine/TheSimonMachine'
import PrototypeResults from './PrototypeResults'
import ThePipesPassword from './thePipes/ThePipesPassword'
import ThePipes from './thePipes/ThePipes'
import TheChainedCupboard from './TheChainedCupboard'

import simonProcess from '../../../../images/clues/laboratory/simonProcess.png'
import pipesProcess from '../../../../images/clues/laboratory/pipesProcess.png'
import pipesProcess2 from '../../../../images/clues/laboratory/pipesProcess2.png'
import pipesSolution from '../../../../images/clues/laboratory/pipesSolution.png'


const laboratoryData = [
    {
        name: 'The TheChalkboard',
        id: 'chalkboard',
        sceneText: "A chalkboard full of notes",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheChalkboard />,
        cluesAvailable: false
    },
    {
        name: 'The Sound Machine',
        id: 'soundMachine',
        sceneText: "A strange machine with lots of buttons",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheSoundMachine />,
        cluesAvailable: true,
        clues: [
            {
                text: 'Use the chalkboard and page 17 to work out the password.'
            },
            {
                text: "Each number on the chalkboard relates to an element on page 17. Once you know which elements you need, take their 1 or 2 letter shorthand and put the letters together to make a word."
            },
            {
                text: "The elements from the chalkboard create the password: SECRETS. Use this to power the sound machine."
            },
            {
                text: "Use page 2 to work out which buttons to press on the sound machine. The next hint will be the solution."
            },
            {
                text: 'Pressing the sound waves shown on page 2 gives the message CLICK ON THE MICROSCOPE. Click on the microscope in the lab.'
            }
        ]
    },
    {
        name: 'The Lock Box',
        id: 'lockBox',
        sceneText: "A strong lock box with something heavy inside",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheLockBox />,
        cluesAvailable: true,
        clues: [
            {
                text: 'The 4 digit password for the lock box is hidden on page 8.'
            },
            {
                text: 'There is an image on page 8 which is missing a triangle shape. Have you seen that missing piece anywhere?'
            },
            {
                text: 'The missing piece is on page 1. Use scissors to cut it out and position it correctly on page 8. The next hint will be the solution.'
            },
            {
                text: 'The lock box code is: 5643'
            }
        ] 
    },
    {
        name: 'The Simon Machine',
        id: 'simonMachine',
        sceneText: "Another of the Professor's clever contraptions",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheSimonMachine />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Press the buttons in the same sequence as shown by the lights. Complete 3 sequences in a row.'
            },
            {
                text: 'The lines at the side of the buttons are the same as the lines beside the lights. The next hint will prevent the buttons from rotating.',
                image: simonProcess
            },
            {
                text: 'The buttons will not rotate anymore.'
            }
        ]
    },
    {
        name: 'Prototype Results',
        id: 'prototypeOne',
        sceneText: "A collection of important papers",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <PrototypeResults option='1'/>,
        cluesAvailable: false,
        clues: [
            {
                text: 'Make sure you have found two different collections of prototype results before attempting this one.'
            },
            {
                text: 'Once you have completed the Sound Machine and the Simon Machine, use the two collections of prototype results to fill in the table on page 12.'
            },
            {
                text: 'On page 12, failed trials should be filled in, succesful trials should be left blank. Make sure you have also completed the sound machine to find all of the prototype results.'
            },
            {
                text: 'When looking at the prototype results some of the information is obscurred. You will need to use logical reasoning and process of elimination to make sure you have filled in the correct results.'
            },
            {
                text: 'Once you have filled in the table on page 12, you will be able to see a word. This is the password to get the pipes working. The next hint will be the solution.'
            },
            {
                text: 'The password for the pipes is: TIN'
            }
        ]
    },
    {
        name: 'Prototype Results 2',
        id: 'prototypeTwo',
        sceneText: "The Professor's laboratory. A place of science.",
        puzzleVisible: true,
        puzzleLocked: true,
        component: <PrototypeResults option='2'/>,
        cluesAvailable: false
    },
    {
        name: 'The Pipes Password',
        id: 'pipesPassword',
        sceneText: "Pipes for transporting chemicals. But the pump isn't working",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <ThePipesPassword />,
        cluesAvailable: false
    },
    {
        name: 'The Pipes',
        id: 'pipes',
        sceneText: "Pipes for transporting chemicals",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <ThePipes />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Use page 11 to calculate how much chemical from each pipe you need. Click on the pipe handles to start and stop the flow.'
            },
            {
                text: "The pipe symbols can be combined to create 3 shapes; hexagon, triangle, diamond. How many of each pipe symbol are needed to create 2 diamonds?",
                image: pipesProcess
            },
            {
                text: 'You need 2 triangles & 4 hexagons to make 2 diamonds. The next hint will be the solution.',
                image: pipesProcess2
            },
            {
                text: 'From left to right the pipes need: 16 8 2',
                image: pipesSolution
            }
        ]
    },
    {
        name: 'The Chain',
        id: 'chainedCupboard',
        sceneText: "This cupboard is held closed by a chain",
        specialIcon: 'fas fa-link',
        puzzleVisible: true,
        puzzleLocked: true,
        component: <TheChainedCupboard finalPuzzle />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Click on the chemical flask in your inventory and select the chain icon to use it.'
            }
        ]
    }
]

export default laboratoryData